import { App } from 'antd';
import { PermissionKey } from '@evimo/types/enums/permission-key';
import { AuthGuard } from '~/app/auth/guard/AuthGuard';
import { KmsPageView } from './KmsPageView';
import { useKmsPage } from './hooks/useKmsPage';

export function KmsPageContainer() {
  return (
    <AuthGuard requiredPermissions={[PermissionKey.DOCUMENTS_READ]}>
      <App>
        <KmsPageContent />
      </App>
    </AuthGuard>
  );
}

function KmsPageContent() {
  const page = useKmsPage();
  return (
    <KmsPageView
      activeTab={page.activeTab}
      onTabChange={page.onTabChange}
      hitlBadgeCount={page.hitlBadgeCount}
      isSuperAdmin={page.isSuperAdmin}
      isPlatformLibrary={page.isPlatformLibrary}
      libraryMode={page.libraryMode}
      onLibraryModeChange={page.onLibraryModeChange}
      organizationId={page.organizationId}
      effectiveOrganizationId={page.effectiveOrganizationId}
      selectedOrganizationName={page.selectedOrganizationName}
      organizationOptions={page.organizationOptions}
      onOrganizationIdChange={page.onOrganizationIdChange}
      browseTarget={page.browseTarget}
      onBrowseTargetChange={page.onBrowseTargetChange}
      selectedAsset={page.selectedAsset}
      linkedDocuments={page.linkedDocuments}
      linkedDocumentsTotal={page.linkedDocumentsTotal}
      linkedDocumentsPage={page.linkedDocumentsPage}
      linkedDocumentsPageSize={page.linkedDocumentsPageSize}
      linkedDocumentsPageSizeOptions={page.linkedDocumentsPageSizeOptions}
      onLinkedDocumentsPageChange={page.onLinkedDocumentsPageChange}
      documentSearch={page.documentSearch}
      onDocumentSearchChange={page.onDocumentSearchChange}
      documentTypeFilter={page.documentTypeFilter}
      onDocumentTypeFilterChange={page.onDocumentTypeFilterChange}
      statusFilter={page.statusFilter}
      onStatusFilterChange={page.onStatusFilterChange}
      isLoadingLinkedDocuments={page.isLoadingLinkedDocuments}
      linkedDocumentsError={page.linkedDocumentsError}
      assets={page.assets}
      totalAssets={page.totalAssets}
      isLoadingAssets={page.isLoadingAssets}
      assetPage={page.assetPage}
      onAssetPageChange={page.onAssetPageChange}
      assetSearch={page.assetSearch}
      onAssetSearchChange={page.onAssetSearchChange}
      isUploadModalOpen={page.isUploadModalOpen}
      openUploadModal={page.openUploadModal}
      closeUploadModal={page.closeUploadModal}
    />
  );
}
